import { authFetch } from '../Auth/apiClient'

export function deleteProduct(instance, productId) {
    return authFetch(instance, `/api/delete_product/${productId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
    });
}